import React, { Component } from "react";

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import {
  Typography,
  Tabs,
  Tab,
} from "@material-ui/core";

import screeningStyles from "./screeningDetails.module.css";
import commonStyles from '../common/common.module.css';
import Screening from "../../models/Screening";
import Exemption from "../../models/Exemptions";
import AwbParams from "../../models/AwbParams";

import ScreeningCard from "./ScreeningCard";
import SecurityConsginment from "./SecurityConsginment";
import { extractAwbCodeAndNumber } from "../../utils/airwayBill";
import screeningRemote from "../../api/screeningRemote";
import ResponseError from "../../models/ResponseError";
import ApiResponse from "../../models/ApiResponse";
import { connect } from "react-redux";
import { receiveError } from "../../store/actions/notificationAction";
import { baseUrl } from "../../api/baseUrl";
import ScreeningConsignment, { SecurityConsignmentResponse } from "../../models/ScreeningConsignment";
import SecurityLogs from "../../models/SecurityLogs";
import { receiveButtonState } from "../../store/actions/disableApiCall";

const styles = (theme: Theme) =>

  createStyles({
    red: {
      backgroundColor: 'red !important',
    },
    activeTab: {
      '&.MuiTab-textColorInherit.Mui-selected': {
        backgroundColor: 'var(--primaryblue) !important',
      }
    },
    tabWrapper: {
      '& .MuiTabs-indicator': {
        display: 'none'
      }
    }
  });

interface ConsignmentErrors {
  contents: string;
  security_status: string;
};

interface ConsignmentDisabled {
  contents: boolean;
  transit: boolean;
  additional_info: boolean;
};

interface ScreeningDetailsComponentProps {
  receiveError: (error: ResponseError) => void;
  classes: any;
  flight: string;
  awbNumber: string;
  awbVersion: number;
  piecesSplit: Array<Screening>;
  changePieces: (event: any) => void;
  selectFlight: (event: any) => void;
  changeDetails: (event: any, type: string) => void;
  selectDate: (date: Date, index: number, type: string) => void;
  submitScreening: (event: any, i: number) => void;
  handleDateChange: (date: Date, index: number) => void;
  editCard: (index: number) => void;
  deleteCard: (index: number) => void;
  handleSelectChange: (event: any, type: string) => void;
  addCard: () => void;
  exemptions: Exemption;
  measures: Array<string>;
  alarmResolutions: Array<string>;
  setUserManually: (event: any) => void;
  setButtonState: (value: boolean) => void;
  buttonState: boolean;
  orderNumber: string;
  disableScreening: boolean;
  errorMessage?: string;
};

interface ScreeningDetailsComponentState {
  tabValue: number;
  consignment: ScreeningConsignment;
  consignmentDisabled: ConsignmentDisabled;
  userLogs: Array<SecurityLogs>;
  consignmentErrors: ConsignmentErrors;
  disableSave: boolean;
  disableEmail: boolean;
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
};

const initialConsignmentErrors: ConsignmentErrors = {
  contents: '',
  security_status: '',
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-prevent-tabpanel-${index}`}
      aria-labelledby={`scrollable-prevent-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Typography>{children}</Typography>
      )}
    </div>
  );
}

class ScreeningDetailsComponent extends Component<ScreeningDetailsComponentProps, ScreeningDetailsComponentState>  {

  state: Readonly<ScreeningDetailsComponentState> = {
    tabValue: 0,
    consignment: {} as ScreeningConsignment,
    consignmentDisabled: {
      contents: true,
      transit: true,
      additional_info: true
    },
    userLogs: [],
    consignmentErrors: initialConsignmentErrors,
    disableSave: true,
    disableEmail: false
  };

  componentDidMount() {
    this.fetchScreeningConsignment();
  }

  componentDidUpdate(prevProps: ScreeningDetailsComponentProps) {
    if(prevProps.piecesSplit !== this.props.piecesSplit) {
      this.fetchScreeningConsignment();
    }
  }

  changeTabValue = (event: React.ChangeEvent<{}>, newValue: number): void => {
    let tabValue = 0;
    if(newValue == 1 && this.props.piecesSplit && this.props.piecesSplit[0].id) {
      tabValue = newValue;
    }
    this.setState({ tabValue });
  }

  print = (): void => {
    const awbParams: AwbParams = extractAwbCodeAndNumber(this.props.awbNumber);
    let url: string = `${baseUrl}screening_consignment/${awbParams.awbCode}/${awbParams.awbNumber}/${this.props.awbVersion}/file?type=app&orderNumber=${this.props.orderNumber}`;
    window.open(url);
    setTimeout(() => {
      this.fetchScreeningConsignment();
    }, 2000);
  }

  changeConsignmentField = (event: any): void => {
    const id: any = event.target.id || event.target.name;
    const value = event.target.value;
    let consignment: any = { ...this.state.consignment };
    consignment[id] = value;
    this.setState({ consignment }, () => {
      this.validate();
    });
  }

  saveConsignment = (): void => {
    const valid = this.validate();
    if(valid) {
      this.props.setButtonState(true);
      const awbParams: AwbParams = extractAwbCodeAndNumber(this.props.awbNumber);
      screeningRemote.saveScreeningConsignment(awbParams.awbCode, awbParams.awbNumber, this.props.awbVersion, this.state.consignment).then((resp: ApiResponse<number>) => {
        const consignment: number | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
        this.props.setButtonState(false);
        if (consignment) {
          this.fetchScreeningConsignment();
        }
  
        if (error) {
          this.props.receiveError(error);
        }
      });
    }
   
  }

  validate = (): boolean => {
    let consignmentErrors: any = {...initialConsignmentErrors};
    const consignment: any = { ... this.state.consignment };
    let hasError: boolean = false;
    Object.entries(consignment).forEach(([key, value]) => {
      if (value === '' && key == 'security_status' ) {
        consignmentErrors[key] = 'Add';
        hasError = true;
      }
      if (value === '' && key == 'contents') {
        consignmentErrors[key] = 'Add';
        hasError = true;
      }
    });
    const disableSave = hasError;
    if(!hasError) {
      consignmentErrors = initialConsignmentErrors;
    }
    this.setState({ consignmentErrors, disableSave });
    return !hasError;
  }

  enableFields = (field: string) => {
    let consignmentDisabled: any = { ...this.state.consignmentDisabled };
    consignmentDisabled[field] = !consignmentDisabled[field];
    this.setState({ consignmentDisabled });
  }

  fetchScreeningConsignment = (): void => {
    const awbParams: AwbParams = extractAwbCodeAndNumber(this.props.awbNumber);
    screeningRemote.getScreeningConsignment(awbParams.awbCode, awbParams.awbNumber, this.props.awbVersion, this.props.orderNumber).then((resp: ApiResponse<SecurityConsignmentResponse>) => {
      const result: SecurityConsignmentResponse | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (result) {
        const disableSave = false;
        this.setState({ consignment: result.consignmentDetails, userLogs: result.userLogs, disableSave }, () => {
          // this.validate();
        });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  emailScreeningConsignment = (): void => {
    this.setState({ disableEmail: true }, () => {
      const awbParams: AwbParams = extractAwbCodeAndNumber(this.props.awbNumber);
      screeningRemote.emailScreeningConsignment(awbParams.awbCode, awbParams.awbNumber, this.props.awbVersion, this.props.orderNumber).then((resp: ApiResponse<boolean>) => {
        const result: boolean | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
  
        if (result) {
         this.fetchScreeningConsignment();
         this.setState({ disableEmail: false });
        }
  
        if (error) {
          this.props.receiveError(error);
        }
      });
    });
  
  }

  render() {

    const classes = this.props.classes;

    return (
      <div className={ `${screeningStyles.methodCol}` }>
        <Tabs
          value={ this.state.tabValue }
          onChange={ this.changeTabValue }
          scrollButtons="off"
          aria-label="scrollable prevent tabs example"
          className={ `${commonStyles.tabContainer} ${commonStyles.mb4} ${classes.tabWrapper}` }
          variant="fullWidth"
        >
          <Tab className={ `${commonStyles.tab} ${classes.activeTab} $` } label="Screening Details" />
          <Tab className={ `${commonStyles.tab} ${classes.activeTab} $` } label="Consignment Security Declaration" />
        </Tabs>


        <TabPanel value={this.state.tabValue} index={0}>
          <ScreeningCard
            piecesSplit={ this.props.piecesSplit }
            flight={ this.props.flight }
            changePieces={ this.props.changePieces }
            changeDetails={ this.props.changeDetails }
            selectDate={ this.props.selectDate }
            selectFlight={ this.props.selectFlight }
            submitScreening={ this.props.submitScreening }
            handleDateChange={ this.props.handleDateChange }
            editCard={ this.props.editCard }
            deleteCard={ this.props.deleteCard }
            addCard={ this.props.addCard }
            handleSelectChange={ this.props.handleSelectChange }
            measures={ this.props.measures }
            exemptions={ this.props.exemptions }
            alarmResolutions={ this.props.alarmResolutions }
            setUserManually={ this.props.setUserManually }
            disableScreening={ this.props.disableScreening }
            errorMessage={ this.props.errorMessage }
          />
        </TabPanel>
        <TabPanel value={this.state.tabValue} index={1}>
          <SecurityConsginment
            consignment={this.state.consignment }
            consignmentDisabled={ this.state.consignmentDisabled }
            enableFields={ this.enableFields }
            onChange={ this.changeConsignmentField }
            save={ this.saveConsignment }
            userLogs={ this.state.userLogs }
            print={ this.print }
            emailConsignment={ this.emailScreeningConsignment }
            disableSave={ this.state.disableSave }
            consignmentErrors={ this.state.consignmentErrors }
            disableEmail={ this.state.disableEmail }
            buttonState={ this.props.buttonState }
          />
        </TabPanel>
      </div>
    );
  }

};

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    buttonState: state.buttonState
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    setButtonState: (value: boolean) => dispatch(receiveButtonState(value))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ScreeningDetailsComponent));